module.exports = __webpack_public_path__ + "static/img/eec-group-3.ed75656b.png";